import React from 'react';
import Button from 'src/Components/Button_V2';
import styles from './styles.module.scss';
import classnames from 'classnames';

const ScrollMobile = ({
  isHidden,
  onClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.container, !isHidden && styles.active)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Button, {
    title: "Stake Now",
    type: "warning",
    className: styles.btn,
    onClick: onClick
  })));
};

export default ScrollMobile;